import React, { useState } from 'react';
import './SubBallotModal.css';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CircularProgress from '@mui/material/CircularProgress';
import { Snackbar, Alert } from '@mui/material';

const SubBallotModal = ({
    subBallot,
    parentOptionText,
    onSubmit,
    onClose,
    isLoading
}) => {
    const [selectedOptionId, setSelectedOptionId] = useState(null);
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'error'
    });

    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbar({ ...snackbar, open: false });
    };

    const showSnackbar = (message, severity) => {
        setSnackbar({
            open: true,
            message,
            severity
        });
    };

    const handleSubmit = () => {
        if (!selectedOptionId) {
            showSnackbar('Please select an option', 'error');
            return;
        }

        onSubmit(selectedOptionId);
    };

    const getOptionPercentage = (option) => {
        if (subBallot.isVoted && option.voteCount !== undefined) {
            return option.percentage || 0;
        }
        return 0;
    };

    return (
        <div className="sub-ballot-modal-overlay" onClick={onClose}>
            <div
                className="sub-ballot-modal-content"
                onClick={(e) => e.stopPropagation()}
            >
                {/* Header */}
                <div className="sub-ballot-modal-header">
                    <button className="sub-ballot-back-btn" onClick={onClose}>
                        <ArrowBackIcon />
                        <span>Back</span>
                    </button>
                    <h3>Follow-up Question</h3>
                    <button className="sub-ballot-close-btn" onClick={onClose}>
                        <CloseIcon />
                    </button>
                </div>

                {/* Body */}
                <div className="sub-ballot-modal-body">
                    <div className="parent-choice-banner">
                        <span className="parent-choice-label">You selected:</span>
                        <span className="parent-choice-value">"{parentOptionText}"</span>
                    </div>

                    <h2 className="sub-ballot-title">{subBallot.title}</h2>

                    {subBallot.description && (
                        <p className="sub-ballot-description">{subBallot.description}</p>
                    )}

                    <div className="sub-ballot-options-container">
                        {subBallot.options.map((option) => {
                            const percentage = getOptionPercentage(option);
                            const isSelected = subBallot.isVoted
                                ? option.id === subBallot.selectedOptionId
                                : selectedOptionId === option.id;

                            return (
                                <label
                                    key={option.id}
                                    className={`sub-ballot-option-item ${isSelected ? 'selected' : ''} ${subBallot.isVoted ? 'voted' : ''}`}
                                >
                                    <input
                                        type="radio"
                                        name="sub-ballot-option"
                                        value={option.id}
                                        checked={isSelected}
                                        onChange={() => !subBallot.isVoted && setSelectedOptionId(option.id)}
                                        disabled={subBallot.isVoted}
                                    />
                                    <span className="sub-ballot-option-text">{option.value}</span>

                                    {subBallot.isVoted && (
                                        <div className="percentage-display">
                                            {Math.round(percentage)}%
                                        </div>
                                    )}

                                    {/* Progress bar for voted state */}
                                    {subBallot.isVoted && (
                                        <div className="sub-ballot-progress-bar">
                                            <div
                                                className="sub-ballot-progress-fill"
                                                style={{ width: `${percentage}%` }}
                                            />
                                        </div>
                                    )}
                                </label>
                            );
                        })}
                    </div>
                </div>

                {/* Footer */}
                {!subBallot.isVoted ? (
                    <div className="sub-ballot-modal-footer">
                        <button className="sub-ballot-cancel-btn" onClick={onClose}>
                            Cancel
                        </button>
                        <button
                            className="sub-ballot-submit-btn"
                            onClick={handleSubmit}
                            disabled={!selectedOptionId || isLoading}
                        >
                            {isLoading ? (
                                <>
                                    <CircularProgress size={16} style={{ color: '#fff', marginRight: '8px' }} />
                                    <span>Submitting...</span>
                                </>
                            ) : (
                                'Submit Vote'
                            )}
                        </button>
                    </div>
                ) : (
                    <div className="sub-ballot-modal-footer">
                        <button className="sub-ballot-submit-btn" onClick={onClose} style={{ width: '100%' }}>
                            Close
                        </button>
                    </div>
                )}
            </div>

            <Snackbar
                open={snackbar.open}
                autoHideDuration={4000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            >
                <Alert
                    onClose={handleCloseSnackbar}
                    severity={snackbar.severity}
                    sx={{ width: '100%' }}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </div>
    );
};

export default SubBallotModal;
